// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__2W6fN","list":"Menu_list__Obx8b"};